
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import { PropTypes } from 'react';

// utilities
// import cx from 'classnames';
import _ from 'lodash';
import shortId from 'shortid';

// components
import ProgressComponent from '../C_ProgressComponent';


export default class ProgressComponentList extends ProgressComponent {
  static propTypes = {
    profileId: PropTypes.number.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context);

    // increment through alphabet
    let inc = 65; // charcode for 'A'
    this.getIncrementedChar = () => String.fromCharCode(inc++);
  }

  onChange(clientId, prop, event, value) {
    if(!clientId) {
      return console.log('need to supply clientId String!');
    }

    this.setState({showErrors: false});

    // if id exists on tempstate or model, this is an update, otherwise it's a create
    if(this.props[this.props.model][clientId] || _.get(this.props.tempState, [this.props.model, clientId])) {
      this.updateTempState(this.props.model, `${clientId}.${prop}`, event, value);
    } else {
      this.updateTempState(this.props.model, `${clientId}`, event, {
        isNew: true,
        clientId,
        [prop]: value
      });
    }
  }

  addListItem = (cb) => {
    const clientId = `${this.getIncrementedChar()}${shortId.generate()}`;
    this.updateTempState(this.props.model, clientId, null, {
      clientId,
      isNew: true
    });
    if (cb) {
      cb(clientId);
    }
  }

  removeListItem = clientId => {
    if(_.get(this.props.tempState, `${this.props.model}.${clientId}`)) {
      // will remove property from tempState
      this.updateTempState(this.props.model, clientId, null, undefined);
    }
    if(this.props[this.props.model][clientId]) {
      this.updateTempState(this.props.model, clientId, null, Symbol.for('__delete'));
    }
  }

  handleTextFieldUI = (clientId, prop, label) => {
    const propPath = [clientId, prop];
    const tempStatePropPath = [this.props.model].concat(propPath);

    return {
      value: _.get(this.props.tempState, tempStatePropPath, _.get(this.props[this.props.model], propPath, '')),
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.onChange.bind(this, clientId, prop)
    };
  }

  handleDatePickerUI = (clientId, prop, label) => {
    const handlerObj = this.handleTextFieldUI(clientId, prop, label);

    // defult to null instead of string for DatePicker element
    handlerObj.value = handlerObj.value === '' ? null : handlerObj.value;

    return handlerObj;
  }

  handleDropDownMenuUI = (clientId, prop, staticData, label) => {
    const propPath = [clientId, prop];
    const tempStatePropPath = [this.props.model].concat(propPath);

    return {
      value: _.get(this.props.tempState, tempStatePropPath, _.get(this.props[this.props.model], propPath, null)),
      menuItems: typeof staticData === 'string' ? this.props.staticData[staticData] : staticData,
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.onChange.bind(this, clientId, prop)
    };
  }

  getList = (atLeastOne, orderByProps, orderByOrder) => {
    const list = _({})
      .merge(this.props[this.props.model])
      .filter((val, prop) => _.get(this.props.tempState, [this.props.model, prop]) !== Symbol.for('__delete'))
      .orderBy(orderByProps, orderByOrder)
      .concat( // concatenate work experiences currently getting added and sort them by their clientId (which will be alphabetical based on when they were created)
        _(this.props.tempState[this.props.model])
          .pickBy(value => value.isNew)
          .orderBy(['clientId'], ['asc'])
          .value()
      )
      .value();

    const clientId = `${this.getIncrementedChar()}${shortId.generate()}`;

    if(atLeastOne && _.isEmpty(list)) {
      list.push({
        clientId,
        isNew: true
      });
    }

    return list;
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/C_ProgressComponentList/index.js